// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7011e530","513":"fac02f20","703":"c97af431","787":"884cd81a"}[chunkId] + ".chunk.js";
};